import {
  mapGetters,
  mapMutations,
} from 'vuex';


import FleetIcon from '@/assets/images/icons/fleet.svg';
import LeaseIcon from '@/assets/images/icons/lease.svg';
import CustomerIcon from '@/assets/images/icons/customer.svg';
import PartIcon from '@/assets/images/icons/part.svg';

export default {
  name: 'VehiculeTypePicker',
  components: {
    FleetIcon,
    LeaseIcon,
    CustomerIcon,
    PartIcon,
  },
  props: {},
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      vehiculeType: 'getVehiculeType',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setVehiculeTypeMutation: 'SET_VEHICULETYPE',
    }),
    setVehiculeType(vehiculeType) {
      this.setVehiculeTypeMutation(vehiculeType);
    },
  },
};
